import { Chat } from '@/components/Chat'

export function KobaPage() {
  // Default webhook URL - can be changed based on app logic
  const defaultWebhookUrl = 'https://n8n.calintent.com/webhook/api/koba/chat'

  return (
    <Chat 
      webhookUrl={defaultWebhookUrl}
    />
  )
}
